import { render, staticRenderFns } from "./total.vue?vue&type=template&id=bb2b0b44&scoped=true"
import script from "./total.vue?vue&type=script&lang=js"
export * from "./total.vue?vue&type=script&lang=js"
import style0 from "./total.vue?vue&type=style&index=0&id=bb2b0b44&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb2b0b44",
  null
  
)

export default component.exports